<!--
 * @FileDescription: 售后订单详情-Web
 * @Author: 陈文景
 * @Date: 2022-11-07 18:28:30
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <div style="margin-top: 8px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fontfine" :to="{ path: '/order/sales' }">{{ $t('Order.Sales.Details.Web.Index.RefundingOrder') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('Order.Sales.Details.Web.Index.RufundOrderDetails') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="status">
      <div class="tips">
        <div class="refund-status">
          <div class="result">
            <span class="title">{{ $t('Order.Sales.Details.Web.Index.OrderInformation') }}</span>
            <p class="time">
              <span>{{ $t('Order.Sales.Details.Web.Index.ReviewTime') }}: {{ defaultTips(formatTimeStamp(details.returnsDate)) }}</span>
              <span class="code">{{ $t('Order.Sales.Details.Web.Index.ReviewID') }}: {{ defaultTips(details.returnsId) }}</span>
            </p>
            <p class="process-info">
              <i :class="['circle', details.status === 0 ? 'info' : details.status === 1 ? 'warning' : details.status === 2 || details.status === 4 ? 'success' : details.status === 3 ? 'danger' : 'unknown']" />
              <span class="process">{{ ordersStatus(details.status) }}</span>
              <span class="reason">{{ defaultTips(details.refundReason) }}</span>
            </p>
            <div class="f--c">
              <div class="item pointer" v-for="(item, index) in details.refundImage" :key="`${item}${index}`">
                <div style="position: relative;">
                    <el-image :src="item" :preview-src-list="[item]"></el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="refund-record">
          <el-button round @click="showRefundRecord">{{ $t('Order.Sales.Details.Web.Index.RefundRecord') }}</el-button>
        </div>
      </div>

      <div class="details">
        <div class="list">
          <template v-if="details.packItems && details.packItems.length">
            <div v-for="pack in details.packItems" :key="pack.omsPackId">
              <div class="header">
                <h3>{{ $t('Order.Sales.Details.Web.Index.RufundInformation') }}</h3>
                <div class="order-info">
                  <span class="order-code">{{ $t('Order.Sales.Details.Web.Index.OrderID') }}: {{ defaultTips(pack.kkOrderId) }}</span>
                  <span class="tracking-code">{{ $t('Order.Sales.Details.Web.Index.ParcelCode') }}: {{ defaultTips(pack.omsPackId) }}</span>
                  <span class="order-time">{{ $t('Order.Sales.Details.Web.Index.PaymentTime') }}: {{ defaultTips(formatTimeStamp(pack.payDate)) }}</span>
                </div>
              </div>
              <div>
                <SkuInfoItemTwo v-for="item in pack.items" :key="item.skuCode" :data="item" />
              </div>
            </div>
          </template>

          <template v-else>
            <div class="not-data">
              <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
              <div class="tips-text">{{ $t('Order.Sales.Details.Web.Index.NoRecord') }}</div>
            </div>
          </template>
        </div>

        <div class="info">
          <div class="top">
            <div class="amount-info">
              <h3 class="title">{{ $t('Order.Sales.Details.Web.Index.RefundedAmount') }}</h3>
              <p>
                <span>{{ $t('Order.Sales.Details.Web.Index.Subtotal') }}</span>
                <span class="money">{{ `US $${amountTips(details.skusAmount)}` }}</span>
              </p>
              <p>
                <span>{{ $t('Order.Sales.Details.Web.Index.ShippingFee') }}</span>
                <span class="money">{{ `US $${amountTips(details.freightAmount)}` }}</span>
              </p>
              <p>
                <span>{{ $t('Order.Sales.Details.Web.Index.PromoCode') }}</span>
                <span class="money">{{ `- US $${amountTips(details.promotionAmount)}` }}</span>
              </p>
              <p>
                <span>{{ $t('Order.Sales.Details.Web.Index.Coupon') }}</span>
                <span class="money">{{ `- US $${amountTips(details.couponTicketAmount)}` }}</span>
              </p>
            </div>
            <div class="refund-info">
              <span>{{ $t('Order.Sales.Details.Web.Index.Total') }}</span>
              <span>{{ `- US $${amountTips(details.totalAmount)}` }}</span>
            </div>
          </div>

          <div class="button">
            <h3 class="title">{{ $t('Order.Sales.Details.Web.Index.ShippingAddress') }}</h3>
            <div class="info">
              <p>
                <span v-if="ifExist('recipient')">{{ details.address.recipient }}</span> <span v-if="ifExist('phone')">{{ details.address.phone }}</span>
              </p>
              <p v-if="ifExist('street1')">{{ details.address.street1 }}</p>
              <p v-if="ifExist('street2')">{{ details.address.street2 }}</p>
              <p>
                <span v-if="ifExist('city')">{{ details.address.city }}</span> <span v-if="ifExist('province')">{{ details.address.province }}</span> <span v-if="ifExist('country')">{{ details.address.country }}</span> <span v-if="ifExist('zip')">{{ details.address.zip }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 退款记录对话框 -->
    <RefundRecordDialog ref="refundRecordDialog" />
  </div>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/util/moment'
import SkuInfoItemTwo from './components/SkuInfoItemTwo.vue'
import RefundRecordDialog from './components/RefundRecordDialog.vue'

export default {
  components: {
    SkuInfoItemTwo,
    RefundRecordDialog
  },
  data() {
    return {
      formatTimeStamp,

      loading: false,

      details: {} // 详情
    }
  },
  computed: {
    ordersStatus() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return `${this.$t('Order.Sales.Details.Web.Index.Processing')}` // 处理中
          case 1:
            return `${this.$t('Order.Sales.Details.Web.Index.Processing')}` // 审核中
          case 2:
            return `${this.$t('Order.Sales.Details.Web.Index.Refunding')}` // 退款中
          case 3:
            return `${this.$t('Order.Sales.Details.Web.Index.Rejected')}` // 已拒绝
          case 4:
            return `${this.$t('Order.Sales.Details.Web.Index.Completed')}` // 已完成
          default:
            return '-'
        }
      }
    },
    amountTips() {
      return (value) => value || 0
    },
    ifExist() {
      return (field) => (this.details && this.details.address && this.details.address[field] ? this.details.address[field] : undefined)
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    this.getAfterSalesOrderDetails()
  },
  methods: {
    /**
     * API 获取售后订单详情
     */
    async getAfterSalesOrderDetails() {
      try {
        this.loading = true
        let { data } = await API.getAfterSalesOrderDetails(this.$route.query.returnsId)
        data.packItems = this.reformData(data.packItems || [])
        this.details = data
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 改造未发货列表数据
     *
     * @param {Array} data 原数据
     * @returns {Array} 改造后的数据
     */
    reformData(data) {
      if (data.length) {
        data.forEach((outside) => {
          if (outside && outside.items && outside.items.length) {
            outside.items = outside.items.map((item) => ({
              ...item,
              options:
                JSON.parse(item.options) &&
                JSON.parse(item.options)
                  .map((option) => JSON.parse(option).value)
                  .join('、')
            }))
          }
        })
      }
      return data
    },

    /**
     * 显示退款记录对话框
     */
    showRefundRecord() {
      this.$refs.refundRecordDialog.show(this.details.packItems[0].kkOrderId)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1192px;
  margin: 0 auto;

  .fontfine {
    /deep/span {
      font-weight: normal;
    }
  }

  .status {
    margin-top: 12px;
    .tips {
      display: flex;
      padding: 14px 32px;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      .refund-status {
        flex: 1;
        position: relative;
        height: 100%;
        .review {
          position: absolute;
          top: 50%;
          left: 0;
          font-size: 18px;
          font-weight: 500;
          transform: translateY(-50%);
        }
        .result {
          height: 100%;
          color: #747a87;
          font-size: 14px;
          font-weight: 400;
          .title {
            color: #000;
            font-size: 18px;
            font-weight: 500;
          }
          .time {
            margin: 15px 0;
            .code {
              margin-left: 38px;
            }
          }
          .process-info {
            display: flex;
            align-items: center;
            .circle {
              display: inline-block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              &.success {
                background-color: #99c41c;
              }
              &.warning {
                background-color: #e6a23c;
              }
              &.danger {
                background-color: #f56c6c;
              }
              &.info {
                background-color: #909399;
              }
              &.unknown {
                background-color: #f5f7f7;
              }
            }
            .process {
              margin-left: 6px;
            }
            .reason {
              margin-left: 38px;
            }
          }
        }
      }
      .refund-record {
        .el-button {
          width: 150px;
          height: 44px;
          border-radius: 22px;
        }
      }
    }
    .details {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .list {
        width: 830px;
        padding: 15px 20px;
        background-color: #fff;
        .header {
          h3 {
            font-size: 18px;
            font-weight: 500;
          }
          .order-info {
            display: flex;
            color: #747a87;
            font-size: 14px;
            margin: 12px 0 18px;
            justify-content: space-between;
            .tracking-code {
              color: #99c41c;
            }
          }
        }
        .not-data {
          height: 100%;
          text-align: center;
          .tips-text {
            color: #747a87;
            margin-top: 28px;
          }
        }
      }
      .info {
        width: 352px;
        .top {
          width: 100%;
          .amount-info {
            padding: 22px;
            background-color: #fff;
            border-bottom: 1px solid #f5f7f7;
            .title {
              font-size: 18px;
              font-weight: 500;
            }
            p {
              display: flex;
              color: #747a87;
              font-size: 14px;
              font-weight: 500;
              margin-top: 20px;
              justify-content: space-between;
              .money {
                color: #10141d;
                font-size: 16px;
                font-weight: 500;
              }
            }
          }
          .refund-info {
            display: flex;
            color: #000;
            font-size: 18px;
            font-weight: 500;
            padding: 22px 12px;
            align-items: center;
            background-color: #fff;
            justify-content: space-between;
          }
        }
        .button {
          width: 100%;
          margin-top: 10px;
          padding: 12px;
          background-color: #fff;
          .title {
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 8px;
          }
          .info {
            width: 100%;
            color: #8b93a3;
            font-size: 14px;
          }
        }
      }
    }
  }
  .item{
    margin: 10px;

    .el-image{
      width: 70px;
      height: 72px;
      border-radius: 6px;
      border: 1px solid #CDD4DD;
    }
  }
}
</style>
